import { motion } from "framer-motion";
import { MainPhotoSection } from "../MainPage/MainPageStyles";
import {
  animationFromTheSide,
  arrAnimation,
} from "../../animations/animations";
import { useTranslation } from "react-i18next";
import ContactUsMainPhoto from "../../images/contactUsMainPhoto.png";
import { ContactUsMAinSec, MapWrapper } from "./ContactUsPageSyles";
import Mail from "../../images/ContactUs/mail.png";
import Time from "../../images/ContactUs/time.png";
import Location from "../../images/ContactUs/location.png";
import { NavLink } from "react-router-dom";
import { MapContainer, Marker, Popup, TileLayer } from "react-leaflet";
import { Icon } from "leaflet";

export const ContactsPage = () => {
  const { t } = useTranslation();

  const defaultIcon = new Icon({
    iconUrl: "https://unpkg.com/leaflet/dist/images/marker-icon.png",
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
  });

  return (
    <main>
      <MainPhotoSection style={{ background: "#074275" }}>
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ amount: 0.3, once: true }}
          className="container__standart flex__between flex__column"
          style={{ marginBottom: "0px" }}
        >
          <motion.div custom={1} variants={arrAnimation}>
            <h1>{t("contactUsPage.title1")}</h1>
            <p className="big__text">{t("contactUsPage.title2")}</p>
          </motion.div>
          <motion.div custom={2} variants={arrAnimation}>
            <img src={ContactUsMainPhoto} alt="#" />
          </motion.div>
        </motion.div>
      </MainPhotoSection>
      <ContactUsMAinSec>
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ amount: 0.3, once: true }}
          className="container__standart"
        >
          <div className="container__flex">
            <div className="div__column">
              <motion.h2 variants={animationFromTheSide}>
                {t("contactUsPage.blockInfo1Tit")}
              </motion.h2>
              <div className="info__line">
                <img src={Mail} alt="mail" />
                {t("contactUsPage.blockInfo11")}
                <NavLink to="/" className="link__color">
                  support@testtraders.com
                </NavLink>
              </div>
              <div className="info__line">
                <img src={Mail} alt="mail" />
                <NavLink to="/" className="link__color">
                  {t("contactUsPage.blockInfo12")}
                </NavLink>
              </div>
              <div className="info__line">
                <img src={Location} alt="mail" />
                {t("contactUsPage.blockInfo13")}
              </div>
              <div className="info__line">
                <img src={Time} alt="mail" />
                <div>
                  <p>{t("contactUsPage.blockInfo14")}</p>
                  <p>{t("contactUsPage.blockInfo15")}</p>
                </div>
              </div>
            </div>
            <div className="div__column">
              <MapWrapper>
                <MapContainer
                  center={[40.785091, -73.968285] as [number, number]}
                  zoom={17}
                  style={{ width: "100%", height: "100%" }}
                >
                  <TileLayer
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                  />
                  <Marker position={[40.785091, -73.968285]} icon={defaultIcon}>
                    <Popup>{t("contactUsPage.blockInfo21")}</Popup>
                  </Marker>
                </MapContainer>
              </MapWrapper>
            </div>
          </div>
        </motion.div>
      </ContactUsMAinSec>
    </main>
  );
};
